import WithRender from "../../templates/tables/quantityTable.html";

export default WithRender({
  computed: {
    name: function () {
      return this.quantityTableName ?? "Quantity";
    }
  },
  props: ["quantityTableName"]
});
